type VersionNoticeParams = Readonly<{
  baselineVersion?: string | null;
  latestVersion?: string | null;
  dismissedVersion?: string | null;
}>;

export const shouldShowVersionNotice = ({ baselineVersion, latestVersion, dismissedVersion }: VersionNoticeParams) => {
  if (!baselineVersion || !latestVersion) return false;
  if (latestVersion === baselineVersion) return false;
  return latestVersion !== dismissedVersion;
};
